import React, { useEffect } from "react";
import AboutTravel from "../components/pages/TravelAwards/AboutTravel";
import PageHeader from "../components/pages/TravelAwards/PageHeader";
import OurPurpose from "../components/pages/TravelAwards/OurPurpose";
import Unique from "../components/pages/TravelAwards/Unique";
import { Helmet, HelmetProvider } from "react-helmet-async";

const TravelAwards = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Travel Bloggers | Awards</title>
          <meta name="description" content="Travel Bloggers Awards" />
        </Helmet>
        <div>
          <PageHeader />
          <AboutTravel />
          <OurPurpose />
          <Unique />
        </div>
      </HelmetProvider>
    </>
  );
};

export default TravelAwards;
